/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS8 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_7;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_8;
    },
    getDownloadName() {
      return ns.IOS8.nice_name;
    },
  });

  Object.assign(IOS8, {
    slug: `ios_8`,
    nice_name: `iOS 8 adoption`,
    description: `How quickly are consumers upgrading to iOS 8?`,
  });
  ns.IOS8 = IOS8;
});

}.call(window));